/* src/app/components/dialogs/sub-account-selector-dialog/sub-account-selector-dialog.component.less */
.sub-account-selector-dialog-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
/*# sourceMappingURL=sub-account-selector-dialog.component.css.map */
